import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const F_TARIFQTE_SCHEMA_LITERAL = {
    title: 'Schéma F_TARIFQTE',
    description: 'F_TARIFQTE',
    version: 0,
    keyCompression: false,
    primaryKey: { key : 'CBMARQ_PK', fields : ['CBMARQ'], separator : '' },
    type: 'object',
    properties: {
        CBMARQ_PK: { type: 'string', maxLength : 10 },
        CBMARQ: { type: 'number' },
        AR_REF: { type: 'string' },
        TQ_REFCF: { type: 'string' },
        TQ_BORNEINF: { type: 'number' },
        TQ_BORNESUP: { type: 'number' },
        TQ_REMISE01REM_VALEUR: { type: 'number' },
        TQ_REMISE01REM_TYPE: { type: 'number' },
        TQ_REMISE02REM_VALEUR: { type: 'number' },
        TQ_REMISE02REM_TYPE: { type: 'number' },
        TQ_REMISE03REM_VALEUR: { type: 'number' },
        TQ_REMISE03REM_TYPE: { type: 'number' },
        TQ_PRIXNET: { type: 'number' }
    },
    required: [ 'CBMARQ', 'AR_REF', 'TQ_REFCF', 'TQ_BORNEINF', 'TQ_BORNESUP' ]
} as const;

const schemaTyped = toTypedRxJsonSchema(F_TARIFQTE_SCHEMA_LITERAL);
export type RxFTarifQteDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const F_TARIFQTE_SCHEMA: RxJsonSchema<RxFTarifQteDocumentType> = F_TARIFQTE_SCHEMA_LITERAL;
